import React from 'react';
import { Link } from 'react-router-dom';

const SiteFooter: React.FC = () => {
  return (
    <footer className="bg-aspen-deep-eucalyptus dark:bg-aspen-night-sage">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-4 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <div className="flex items-center">
              <img src="/aspen-logomark.webp" alt="Ask Aspen logo" className="h-6 w-auto sm:h-8" width={32} height={32} />
              <span className="ml-2 text-lg sm:ml-3 sm:text-xl font-semibold text-aspen-pearl">Ask Aspen</span>
            </div>
            <p className="text-aspen-gentle-teal text-base">
              AI that messages you for conversation, memory, reminders, and check-ins.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="https://twitter.com/AskAspenApp" target="_blank" rel="noopener noreferrer" className="text-aspen-gentle-teal hover:text-aspen-pearl transition-colors" aria-label="Follow Ask Aspen on X (Twitter)">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/ask-aspen" target="_blank" rel="noopener noreferrer" className="text-aspen-gentle-teal hover:text-aspen-pearl transition-colors" aria-label="Follow Ask Aspen on LinkedIn">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 sm:grid-cols-3 xl:mt-0 xl:col-span-3">
            <div>
              <h3 className="text-sm font-semibold text-aspen-pearl tracking-wider uppercase">Product</h3>
              <ul className="mt-4 space-y-3">
                <li><Link to="/how-it-works" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">How It Works</Link></li>
                <li><Link to="/features" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Features</Link></li>
                <li><Link to="/pricing" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Pricing</Link></li>
                <li><Link to="/account" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Account & billing</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-aspen-pearl tracking-wider uppercase">Resources</h3>
              <ul className="mt-4 space-y-3">
                <li><Link to="/blog" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Blog</Link></li>
                <li><Link to="/faq" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">FAQ</Link></li>
                <li><Link to="/about" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">About</Link></li>
                <li><Link to="/contact" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-aspen-pearl tracking-wider uppercase">Legal</h3>
              <ul className="mt-4 space-y-3">
                <li><Link to="/privacy" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-base text-aspen-gentle-teal hover:text-aspen-pearl transition-colors">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-aspen-moonlit-clay pt-8">
          <p className="text-base text-aspen-gentle-teal xl:text-center">
            &copy; {new Date().getFullYear()} Ask Aspen. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
